import React from "react";
import { Grid } from "semantic-ui-react";
import ContactList from "./ContactList";
import PageHeader from "../SiteLayout/PageHeader";
import AddContact from "./AddContact";

const MainPage = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <PageHeader Name="Contact" Icon="users" Description="Give us your feedback/suggestions!" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <AddContact />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <ContactList />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
export default MainPage;